import { queryKeys } from "@/constants/queries.keys";
import { getUser } from "@/services/user/userApis";
import { useQuery } from "@tanstack/react-query";

export function useUser(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: [queryKeys.user.get],
    queryFn: async () => {
      const res = await getUser();
      if (!res.status) {
        throw new Error(res.message);
      }
      return res.data;
    },
    enabled: options?.enabled,
  });
}
